import React, { CSSProperties } from "react";
import OptionsPopup from "./OptionsPopup";
import { ActionOption } from "../utils";
import {
  SEARCH_GOOGLE_TRANSLATE_LABEL,
  COPY_TO_CLIPBOARD_LABEL,
  CommonPopupProps,
  SEARCH_GOOGLE_LABEL,
} from "./shared";

interface TextSelectionPopupProps extends CommonPopupProps {
  positionStyle?: CSSProperties;
}

const TextSelectionPopup: React.FC<TextSelectionPopupProps> = ({
  isOpen,
  onClose,
  positionStyle,
  onTriggerSearchGoogle,
  onTriggerSearchGoogleTranslate,
  onTriggerCopyToClipboard,
}: TextSelectionPopupProps) => {
  if (positionStyle === undefined) {
    return null;
  }

  const options: ActionOption[] = [
    {
      label: SEARCH_GOOGLE_TRANSLATE_LABEL,
      onClick: onTriggerSearchGoogleTranslate,
    },
    { label: SEARCH_GOOGLE_LABEL, onClick: onTriggerSearchGoogle },
    { label: COPY_TO_CLIPBOARD_LABEL, onClick: onTriggerCopyToClipboard },
  ];

  return (
    <OptionsPopup
      options={options}
      isOpen={isOpen}
      onClose={onClose}
      positionStyle={positionStyle}
    />
  );
};

export default TextSelectionPopup;
